import { render, staticRenderFns } from "./QuickInvoiceDetail.vue?vue&type=template&id=3b006894&scoped=true"
import script from "./QuickInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./QuickInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./QuickInvoiceDetail.vue?vue&type=style&index=0&id=3b006894&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b006894",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b006894')) {
      api.createRecord('3b006894', component.options)
    } else {
      api.reload('3b006894', component.options)
    }
    module.hot.accept("./QuickInvoiceDetail.vue?vue&type=template&id=3b006894&scoped=true", function () {
      api.rerender('3b006894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quickinvoice/QuickInvoiceDetail.vue"
export default component.exports